/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CancelOrderDialog.vue?vue&type=template&id=6dbbfbea"
import script from "./CancelOrderDialog.vue?vue&type=script&lang=js"
export * from "./CancelOrderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dbbfbea')) {
      api.createRecord('6dbbfbea', component.options)
    } else {
      api.reload('6dbbfbea', component.options)
    }
    module.hot.accept("./CancelOrderDialog.vue?vue&type=template&id=6dbbfbea", function () {
      api.rerender('6dbbfbea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/CancelOrderDialog.vue"
export default component.exports